export const NEWS = 'News';